import React from "react";
import Logo from "../../assets/img/Shiperone_Logo.svg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkout, customerDetail, dummySubscription } from "../../redux/actions/onboarding";
import { useLocation, useNavigate } from "react-router-dom";
import { LOGIN } from "../../redux/constants";

function OnboardingSlide8({ completeOnboarding, setPage, page }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.auth);
  const { slider_2_Data, slider_3_Data } = useSelector(
    (state) => state.onboarding
  );
  const { company } = useSelector((state) => state.auth);
  const [url, setUrl] = useState(null);
  const [loader, setLoader] = useState(true);
  const [enterPriseLoader, setEnterPriseLoader] = useState(true);

  const location = useLocation();
  const state = location.state;

  let concateObj = {
    ...slider_2_Data,
    ...slider_3_Data,
    company_id: company.id,
  };
  
  useEffect(() => {
    // if(!state?.payment || state?.payment !== "success"){
    // setLoader(true);
    const payload = {
      current_plan_id: company.current_plan_id,
      customer_id: company.stripe_customer_id,
      company_id: concateObj?.company_id
    };

    dispatch(
      customerDetail(company.stripe_customer_id, concateObj?.company_id, (data) => {
        if (data.status) {
          if (data.data.is_subscribed === false) {
            // console.log(process.env.REACT_APP_STRIPE_PAYMENT)
            if( process.env.REACT_APP_STRIPE_PAYMENT === "true" ) {
              dispatch(
                checkout(payload, (data) => {
                  // console.log(data, data.status, data.data.url);
                  if (data.status) {
                    setUrl(data.data.url);
                  }
                  setLoader(false);
                })
              );
            } else {
              const subPayload = {
                customer_id: company.stripe_customer_id,
                company_id: concateObj?.company_id
              }
              dispatch(
                dummySubscription(subPayload, (data) => {
                  if (data.status) {
                    setLoader(false);
                    setEnterPriseLoader(false);
                  }
                })
              )
            }

          } else {
            setEnterPriseLoader(false)
            setLoader(false);
          }
        }
      })
    );
    // }
  }, []);

  const navigateToDash = () => {
    // Use history.push to navigate to another page
    setPage(page + 1)
    // let authUser = { ...userData };
    // authUser.is_subscribed = true;
    // authUser.is_board_complete = true;
    // dispatch({ type: LOGIN, payload: authUser });
    // localStorage.setItem("user", JSON.stringify(authUser));
    // navigate("/", { replace: true });
  };

  return (
    <div
      className="space-y-4 xl:space-y-6 xl:pt-6 pt-5 h-full"
      style={{ maxHeight: "calc(100% - 42px)" }}
    >
      <div className="flex items-center justify-center">
        <div className="w-24">
          <img alt="Logo" src={Logo} className="object-cover" />
        </div>
      </div>
      <div className="flex justify-center items-center lg:h-1/2 2xl:h-[60%]">
        <div className="w-[80%] bg-[#F2F8FE] rounded-[20px] p-8 h-full flex justify-center items-center">
          <div>
            <p className="text-xl lg:text-2xl font-bold leading-10 tracking-tight text-center space-y-4 -mt-2 text-[#1E293B]">
              <span className="text-[#1E293B]">Onboarding </span>
              <span className="text-[#27AE60]">Completed</span>
            </p>
            <p className="font-medium leading-7 tracking-tight text-center text-[#707070] mt-5 text-base lg:text-lg">
              You have completed your onboarding successfully!
            </p>
            <p className="font-medium leading-7 tracking-tight text-center text-[#707070] text-base lg:text-lg">
              You can schedule a personal demo with one of our team members to
              maximise your experience. If you are not interested in this you
              can also start exploring Shiperone Workflows on your own.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center space-x-16">
        {url ? (
          <a
            href={url}
            target="_self"
            className={`btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-[15px] leading-10 font-semibold cursor-pointer rounded-full w-[300px] h-[50px] ${
              loader && "pointer-events-none"
            }`}
          >
            {loader ? (
              <span className="ml-2">
                <svg
                  className="animate-spin w-4 h-4 fill-current shrink-0"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                </svg>
              </span>
            ) : (
              <p>Make Payment</p>
            )}
          </a>
        ) : (
          <button
            className={`btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-[15px] leading-10 font-semibold cursor-pointer rounded-full w-[300px] h-[50px]  
            }`}
            onClick={navigateToDash}
          >
            { enterPriseLoader ? (
              <span className="ml-2">
                <svg
                  className="animate-spin w-4 h-4 fill-current shrink-0"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                </svg>
              </span>
            ) : (
              <p>Start Exploring on Your Own</p>
            )}
          </button>
        )}

        <a
          href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
          target="__blank"
          className="btn bg-[#2f80ed] hover:bg-[#136be0] text-white rounded-full font-semibold text-[15px] w-[300px] h-[40px] lg:h-[50px]"
        >
          Schedule Personal Demo
        </a>
      </div>
    </div>
    /*<div className={`h-[90%]`}>
      <div className="flex items-center justify-center py-8">
        <div className="h-24 w-24">
          <img
            alt="Logo"
            // src={require("../../assets/img/LogoForOnboarding.png")}
            src={Logo}
            className="object-cover"
          />
        </div>
      </div>
      <div className="flex justify-center items-center">
        <div className="w-[80%] h-[250px] bg-[#F2F8FE] rounded-[20px] p-12">
          <p className="text-[26px] font-bold leading-10 tracking-tight text-center -mt-2">
            <span className="text-[#1E293B]">Onboarding </span>
            <span className="text-[#27AE60]">Completed</span>
          </p>
          <p className="font-medium text-lg leading-7 tracking-tight text-center text-[#707070] mt-5">
            You have completed your onboarding successfully!
          </p>
          <p className="font-medium text-lg leading-7 tracking-tight text-center text-[#707070]">
            You can schedule a personal demo with one of our team members to
            maximise your experience. If you are not interested in this you can
            also start exploring Shiperone Workflows on your own.
          </p>
        </div>
      </div>
      <div className="flex justify-center items-center space-x-16 py-8">
        <button
          className="btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-[15px] leading-10 font-semibold cursor-pointer rounded-full w-[300px] h-[50px]"
          onClick={() => completeOnboarding()}
        >
          Start Exploring on Your Own
        </button>
        <a
          href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
          target="__blank"
          className="btn bg-[#2f80ed] hover:bg-[#136be0] text-white rounded-full font-semibold text-[15px] w-[300px] h-[50px]"
        >
          Schedule Personal Demo
        </a>
      </div>
    </div> */
  );
}

export default OnboardingSlide8;
